import { Separator } from "@chakra-ui/react-v3";
import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { CoverageRowData } from "../tables/coverage";

export type CoverageSidePanelContentProps = {
  data: CoverageRowData;
};

export function CoverageSidePanelContent({ data }: CoverageSidePanelContentProps) {
  return (
    <SidePanelLayout title="Coverage" subtitle={data.provider}>
      <ResourceAnalysis />

      <Separator borderColor="border" />

      <DocumentsSection resources={[data.originalData]} resourceType="Coverage" />
    </SidePanelLayout>
  );
}
